import { transformExtent } from "ol/proj";

export const netherlands3857 = transformExtent(
  [3.0801609999999999, 50.7503657000000032, 7.2274984, 53.7443949999999973],
  "EPSG:4326",
  "EPSG:3857"
);
